import {
  FROM_FIRST_APPROVAL_STATE_KEY,
  HSA_SUCCESS_DISPLAY_MS,
  readFromFirstApprovalNavigationState,
  type FirstApprovalNavigationState,
} from 'constants/endUserNavigationState';

import { useEffect, useRef } from 'react';

import { userPaths } from 'routes/constants';

import { useLocation, useNavigate } from 'react-router-dom';

export function buildHsaPaydaysRedirectState(
  fromFirstApproval: boolean
): FirstApprovalNavigationState | undefined {
  if (!fromFirstApproval) {
    return undefined;
  }

  return { [FROM_FIRST_APPROVAL_STATE_KEY]: true };
}

export function useHsaSuccessAutoRedirect(): void {
  const navigate = useNavigate();
  const location = useLocation();
  const navigationTimeoutRef = useRef<number | null>(null);

  useEffect(() => {
    const fromFirstApproval = readFromFirstApprovalNavigationState(location.state);
    const redirectState = buildHsaPaydaysRedirectState(fromFirstApproval);

    navigationTimeoutRef.current = window.setTimeout(() => {
      navigate(userPaths.hsaPaydays, {
        replace: true,
        ...(redirectState ? { state: redirectState } : {}),
      });
    }, HSA_SUCCESS_DISPLAY_MS);

    return () => {
      if (navigationTimeoutRef.current != null) {
        window.clearTimeout(navigationTimeoutRef.current);
      }
    };
  }, [location.state, navigate]);
}
